<template>
  <section class="w-full py-20">
    <div class="container mx-auto px-4">
      <h2 class="text-3xl font-bold text-blue-900 mb-12 text-center">
        Our Services
      </h2>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        <div class="p-6 border border-blue-100 rounded-lg hover:border-amber-400 transition-colors bg-white shadow-sm" v-for="(service, index) in services" :key="index">
          <component :is="service.icon" class="text-amber-500 mb-4" />
          <h3 class="text-xl font-semibold text-blue-900 mb-2">
            {{ service.title }}
          </h3>
          <p class="text-blue-800/70">{{ service.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Building } from 'lucide-vue-next';
import { Wallet } from 'lucide-vue-next';
import { ShieldCheck } from 'lucide-vue-next';
import { Briefcase  } from 'lucide-vue-next';
export default {
  name: 'ServicesGlobal',
  components: { Building, Wallet, ShieldCheck, Briefcase },
  data() {
    return {
      services: [
        {
          icon: 'Building',
          title: 'Property Management',
          description: 'Comprehensive management services for residential and commercial properties.',
        },
        {
          icon: 'Wallet',
          title: 'Rent Collection',
          description: 'Efficient and reliable rent collection systems with detailed financial reporting.',
        },
        {
          icon: 'ShieldCheck',
          title: 'Maintenance',
          description: 'Prompt and professional maintenance services to preserve property value.',
        },
        {
          icon: 'Briefcase',
          title: 'Tenant Relations',
          description: 'Dedicated tenant support ensuring high retention rates and satisfaction.',
        },
      ],
    };
  },
};
</script>